import getRequest from "util/APIHelperGet";
import postRequest from "util/APIHelperPost";
import putRequest from "util/APIHelperPut";
import deleteRequest from "util/ApiHelperDelete";
import { baseUrl } from "util/APIBaseUrl";

export const fetchChatContacts = async () => {
  return await getRequest(`${baseUrl}/chat/contacts`);
};

export const fetchConversations = async () => {
  return await getRequest(`${baseUrl}/chat/conversations`);
};

export const createConversation = async (targetUserId, targetUserType) => {
  return await postRequest(`${baseUrl}/chat/conversations`, JSON.stringify({ targetUserId, targetUserType }));
};

export const fetchMessages = async (conversationId, limit = 50, offset = 0) => {
  return await getRequest(`${baseUrl}/chat/conversations/${conversationId}/messages?limit=${limit}&offset=${offset}`);
};

export const sendMessageApi = async (conversationId, content, messageType = "text", parentMessageId = null) => {
  return await postRequest(
    `${baseUrl}/chat/conversations/${conversationId}/messages`,
    JSON.stringify({ content, messageType, parentMessageId })
  );
};

export const getUploadUrl = async (conversationId, fileName, fileType) => {
  return await getRequest(
    `${baseUrl}/chat/conversations/${conversationId}/upload-url?fileName=${encodeURIComponent(fileName)}&fileType=${encodeURIComponent(fileType)}`
  );
};

export const uploadFileToS3 = async (uploadUrl, file) => {
  await fetch(uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
};

export const saveFileMessage = async (conversationId, fileName, filePath, fileType, fileSize) => {
  return await postRequest(
    `${baseUrl}/chat/conversations/${conversationId}/file-message`,
    JSON.stringify({ fileName, filePath, fileType, fileSize })
  );
};

export const markAsReadApi = async (conversationId) => {
  return await postRequest(`${baseUrl}/chat/conversations/${conversationId}/read`, JSON.stringify({}));
};

export const addReactionApi = async (messageId, emoji) => {
  return await postRequest(`${baseUrl}/chat/messages/${messageId}/reactions`, JSON.stringify({ emoji }));
};

export const editMessageApi = async (messageId, content) => {
  return await putRequest({
    path: `/chat/messages/${messageId}`,
    body: { content },
    stringifyBody: true,
  });
};

export const deleteMessageApi = async (messageId) => {
  return await deleteRequest(`${baseUrl}/chat/messages/${messageId}`);
};
